export const nameOfFactory =
  <T>() =>
  (name: Extract<keyof T, string>) =>
    name;

type NestedKeys<T> = {
  [K in keyof T]: T[K] extends object
    ? K extends string
      ? `${K}` | `${K}.${NestedKeys<T[K]>}`
      : never
    : K extends string
    ? `${K}`
    : never;
}[keyof T];

export const nameOfFactoryWithNestedKeys =
  <T>() =>
  (name: Extract<NestedKeys<T>, string>) =>
    name;
